import { getFingerPrint } from "@/utils/fingerPrint"
import { fetchAPI } from "@/api/api"

const ACCOUNT_TRACKER_API_URL = "/exchange/member/playerService/accountTracker"

// @ts-ignore
const getFingerprint2 = async (): Promise<string> => {
  const { default: TrafficStatistics2 } = await import("@/utils/trafficStatistics2.js")

  return new Promise(resolve => {
    new TrafficStatistics2().get(function cb(result: unknown) {
      resolve(result as string)
    })
  })
}

const fetch = {
  url: ACCOUNT_TRACKER_API_URL,
  handler: async () => {
    const [fingerprint2, thumbmark] = await Promise.all([
      getFingerprint2(),
      getFingerPrint()
    ])

    const res = await fetchAPI({
      data: {
        fingerprint2,
        thumbmark: JSON.stringify(thumbmark)
      },
      url: ACCOUNT_TRACKER_API_URL
    })

    return res
  }
}

export default fetch
